import React, { useState } from 'react';
import { isFeatureEnabled } from '@vp/ab-reader';
import { TabHeader, Tabs, TabsContents, TabsHeaders, tokens, useScreenClass } from '@vp/swan';
import { Request } from '@99designs/graph-utils/types';
import { __, __product, __vistaRoute } from '@99designs/i18n';
import { Error } from '../components/Error';
import { CombinedProject } from '../hooks/useCombinedProjects';
import { CombinedTabs } from './CombinedTabs';
import { DashboardEmptyState } from './DashboardEmptyState';
import { StartNewProjectButton } from './StartNewProjectButton';

type TabName = 'current' | 'past' | 'draft';

export const DashboardTabs = ({
    currentRequests,
    pastRequests,
    draftRequests,
    projectsError,
    requestsError,
}: {
    currentRequests: CombinedProject[];
    pastRequests: CombinedProject[];
    draftRequests: Request[];
    projectsError?: Error;
    requestsError?: Error;
}) => {
    const [selectedTabId, setSelectedTabId] = useState<TabName>('current');
    const screenSize = useScreenClass();
    const isSmallScreen = screenSize === 'xs' || screenSize === 'sm';

    const tabHeaders = (
        <TabsHeaders display={'flex'}>
            <TabHeader tabId="current">{__('Current Projects')}</TabHeader>
            <TabHeader tabId="past">{__('Past Projects')}</TabHeader>
            {isFeatureEnabled('design_services_draft_briefs') && (
                <TabHeader tabId="draft">{__('Draft Briefs')}</TabHeader>
            )}
        </TabsHeaders>
    );

    if (currentRequests.length === 0 && pastRequests.length === 0 && draftRequests.length === 0) {
        return <DashboardEmptyState state="all" />;
    }

    return (
        <>
            {isSmallScreen && (
                <div
                    style={{
                        width: '100%',
                        textAlign: 'center',
                        marginBottom: tokens.SwanSemSpaceBetweenSubsections,
                    }}
                >
                    <StartNewProjectButton />
                </div>
            )}
            <Tabs
                centerHeaders={isSmallScreen}
                selectedTabId={selectedTabId}
                onRequestTabChange={(requestedTabId) => setSelectedTabId(requestedTabId as TabName)}
                showDividingLine={false}
            >
                {!isSmallScreen ? (
                    <div style={{ display: 'flex' }}>
                        <span
                            style={{ display: 'inline-block', textAlign: 'left', alignSelf: 'end' }}
                        >
                            {tabHeaders}
                        </span>
                        <span
                            style={{
                                width: '100%',
                                display: 'inline-block',
                                textAlign: 'right',
                                alignSelf: 'center',
                            }}
                        >
                            <StartNewProjectButton />
                        </span>
                    </div>
                ) : (
                    tabHeaders
                )}
                <TabsContents>
                    <CombinedTabs
                        selectedTabId={selectedTabId}
                        currentRequests={currentRequests}
                        pastRequests={pastRequests}
                        draftRequests={draftRequests}
                        projectsError={projectsError}
                        requestsError={requestsError}
                    />
                </TabsContents>
            </Tabs>
        </>
    );
};
